"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Renderer = exports.renderHost = exports.SYMBOL_LC_NAME = exports.findElement = void 0;
var react_1 = require("react");
var dependency_1 = require("../utils/dependency");
var renderHost_1 = __importStar(require("./renderHost"));
var fiber_1 = require("./fiber");
Object.defineProperty(exports, "findElement", { enumerable: true, get: function () { return fiber_1.findElement; } });
Object.defineProperty(exports, "SYMBOL_LC_NAME", { enumerable: true, get: function () { return fiber_1.SYMBOL_LC_NAME; } });
var renderHost_2 = require("./renderHost");
Object.defineProperty(exports, "renderHost", { enumerable: true, get: function () { return __importDefault(renderHost_2).default; } });
var Renderer = /** @class */ (function (_super) {
    __extends(Renderer, _super);
    function Renderer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.mountedPackages = new Map();
        _this.state = { compsCount: 0, rootReady: false };
        /** 安装依赖 */
        _this.initDependencies = function () {
            var toBeInstall = [];
            _this.props.packages.forEach(function (pkg) {
                if (pkg.type !== 'cdn')
                    return;
                if (_this.mountedPackages.has(pkg.package))
                    return;
                toBeInstall.push(pkg);
            });
            _this.mountedPackages.forEach(function (installedPkg, installedName) {
                var noExist = !_this.props.packages.find(function (p) { return p.package === installedName; });
                if (noExist) {
                    installedPkg.urls.forEach(function (url) { return (0, dependency_1.removeDependency)(url, window.document); });
                    _this.mountedPackages.delete(installedName);
                    delete window[installedName];
                }
            });
            if (!toBeInstall.length)
                return Promise.resolve();
            return Promise.all(toBeInstall.map(function (pkg) { return Promise.all(pkg.urls.map(function (url) { return (0, dependency_1.installDependency)(url); })).then(function () {
                _this.mountedPackages.set(pkg.package, pkg);
                renderHost_1.default.injectComponent(window[pkg.package]);
                _this.setState({
                    compsCount: Object.keys(renderHost_1.default.components).length,
                });
            }); })).catch(function (e) {
                renderHost_1.default.pageLifeCycle.emit('dependencyInstallFailed', [e]);
            });
        };
        _this.renderChild = function (schema, childrenNodes, extraProps) {
            if (!schema)
                return null;
            if (Array.isArray(schema)) {
                return schema.map(function (s) { return _this.renderChild(s); });
            }
            if (typeof schema === 'string')
                return schema;
            var _a = schema, componentName = _a.componentName, children = _a.children, props = _a.props, id = _a.id, other = __rest(_a, ["componentName", "children", "props", "id"]);
            var comp = renderHost_1.default.getComp(componentName);
            var renderProps = __assign(__assign(__assign({ _other: other }, props), { _LC_ID: id, key: id }), extraProps);
            if (comp === renderHost_1.ComponentNotFound) {
                renderProps.componentName = componentName;
            }
            return (0, react_1.createElement)(comp, renderProps, childrenNodes === undefined ? _this.renderChild(children) : childrenNodes);
        };
        return _this;
    }
    Renderer.prototype.componentDidMount = function () {
        var _this = this;
        window.rendererHost = renderHost_1.default;
        var doNotExposeRendererToParent = this.props.doNotExposeRendererToParent;
        if (window.parent !== window && !doNotExposeRendererToParent) {
            window.parent.rendererHost = renderHost_1.default;
            if (window.parent.engine) {
                window.parent.engine.renderer = renderHost_1.default;
            }
        }
        this.initDependencies();
        renderHost_1.default.pageLifeCycle.on('componentDidMount', function () {
            _this.setState({ rootReady: true });
            window.parent.postMessage('renderer-ready');
        });
    };
    Renderer.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.packages !== this.props.packages) {
            this.initDependencies();
        }
    };
    Renderer.prototype.render = function () {
        // eslint-disable-next-line
        var _a = this.props, schema = _a.schema, packages = _a.packages, doNotExposeRendererToParent = _a.doNotExposeRendererToParent, children = _a.children, extraProps = __rest(_a, ["schema", "packages", "doNotExposeRendererToParent", "children"]);
        // 组件未安装就绪
        var _b = this.state, rootReady = _b.rootReady, compsCount = _b.compsCount;
        if (!compsCount || !schema)
            return null;
        return this.renderChild(schema, rootReady ? this.renderChild(schema.children) : null, extraProps);
    };
    return Renderer;
}(react_1.Component));
exports.Renderer = Renderer;
exports.default = Renderer;
